import { UIElement, UIElementTypes } from '../element';
import TriangleUiListElement from './TriangleUiListElement.svelte';
import '../../types';
import { createBangleJSUiCode } from './bangleCode';
import { elementSelectionStore } from '../../stores/elementsSelection';
import { SCREEN_HEIGHT, SCREEN_WIDTH } from '../../constants';
export var HitBoxTypes;
(function (HitBoxTypes) {
    HitBoxTypes["RECTANGLE"] = "RECTANGLE";
    HitBoxTypes["TRIANGLE"] = "TRIANGLE";
})(HitBoxTypes || (HitBoxTypes = {}));
export class UITriangle extends UIElement {
    constructor(args) {
        super(UIElementTypes.TRIANGLE, args.x, args.y, args.z, args.name, args.id);
        this.width = args.width;
        this.height = args.height;
        this.color = args.color;
        this.rotation = args.rotation;
        this.clickable = args.clickable;
        this.hitBoxType = args.hitBoxType;
        this.points = args.points;
        this.displayHitBox = args.displayHitBox;
        this.hitBoxOffsetXLeft = args.hitBoxOffsetXLeft;
        this.hitBoxOffsetXRight = args.hitBoxOffsetXRight;
        this.hitBoxOffsetYTop = args.hitBoxOffsetYTop;
        this.hitBoxOffsetYBottom = args.hitBoxOffsetYBottom;
        this.vibrate = args.vibrate;
        this.group = args.group;
        if (this.points.length === 0) {
            this.points = [
                {
                    x: this.x,
                    y: this.y,
                },
                {
                    x: this.x + this.width,
                    y: this.y,
                },
                {
                    x: this.x + this.width / 2,
                    y: this.y - this.height,
                }
            ];
        }
    }
    getTriangleCentroid(arr) {
        const centerX = (arr[0].x + arr[1].x + arr[2].x) / 3;
        const centerY = (arr[0].y + arr[1].y + arr[2].y) / 3;
        return [centerX, centerY];
    }
    getRotatedPoints(points) {
        const originPoint = this.getTriangleCentroid(points);
        const newPoint1 = this.rotate(originPoint[0], originPoint[1], points[0].x, points[0].y, this.rotation);
        const newPoint2 = this.rotate(originPoint[0], originPoint[1], points[1].x, points[1].y, this.rotation);
        const newPoint3 = this.rotate(originPoint[0], originPoint[1], points[2].x, points[2].y, this.rotation);
        return [
            {
                x: newPoint1[0],
                y: newPoint1[1],
            },
            {
                x: newPoint2[0],
                y: newPoint2[1],
            },
            {
                x: newPoint3[0],
                y: newPoint3[1],
            },
        ];
    }
    rotate(cx, cy, x, y, angle) {
        const radians = (Math.PI / 180) * angle, cos = Math.cos(radians), sin = Math.sin(radians), nx = (cos * (x - cx)) + (sin * (y - cy)) + cx, ny = (cos * (y - cy)) - (sin * (x - cx)) + cy;
        return [nx, ny];
    }
    convertToCode() {
        this.updatePoints();
        const [p1, p2, p3] = this.getRotatedPoints(this.points);
        return createBangleJSUiCode(this.name, this.width, this.height, this.color, p1, p2, p3, this.z, this.getRenderBox(), this.clickable, this.hitBoxType, {
            hitBoxOffsetXLeft: this.hitBoxOffsetXLeft,
            hitBoxOffsetXRight: this.hitBoxOffsetXRight,
            hitBoxOffsetYTop: this.hitBoxOffsetYTop,
            hitBoxOffsetYBottom: this.hitBoxOffsetYBottom,
        }, this.vibrate);
    }
    convertToUiElement(mountPoint, uiElement, origin) {
        return new TriangleUiListElement({ target: mountPoint, props: { uiElement, origin } });
    }
    sign(p1, p2, p3) {
        return (p1.x - p3.x) * (p2.y - p3.y) - (p2.x - p3.x) * (p1.y - p3.y);
    }
    pointInTriangle(pt, v1, v2, v3) {
        let d1, d2, d3;
        let has_neg, has_pos;
        d1 = this.sign(pt, v1, v2);
        d2 = this.sign(pt, v2, v3);
        d3 = this.sign(pt, v3, v1);
        has_neg = (d1 < 0) || (d2 < 0) || (d3 < 0);
        has_pos = (d1 > 0) || (d2 > 0) || (d3 > 0);
        return !(has_neg && has_pos);
    }
    isSelected(pointerX, pointerY) {
        const rotatedPoints = this.getRotatedPoints(this.points);
        return this.pointInTriangle({ x: pointerX, y: pointerY }, rotatedPoints[0], rotatedPoints[1], rotatedPoints[2]);
    }
    updatePoints() {
        this.points = [
            {
                x: this.x,
                y: this.y,
            },
            {
                x: this.x + this.width,
                y: this.y,
            },
            {
                x: this.x + this.width / 2,
                y: this.y - this.height,
            },
        ];
    }
    addOffsetToPoints(points, originCords) {
        const [point1, point2, point3] = points;
        point1.x += originCords.x;
        point1.y += originCords.y;
        point2.y += originCords.y;
        point2.x += originCords.x;
        point3.y += originCords.y;
        point3.x += originCords.x;
        return [point1, point2, point3];
    }
    renderElement(ctx, originCords) {
        const selected = elementSelectionStore.isSelected(this);
        this.updatePoints();
        const path = new Path2D();
        const [point1, point2, point3] = this.addOffsetToPoints(this.getRotatedPoints(this.points), originCords);
        path.moveTo(point1.x, point1.y);
        path.lineTo(point2.x, point2.y);
        path.lineTo(point3.x, point3.y);
        path.closePath();
        if (selected) {
            ctx.fillStyle = 'green';
        }
        else {
            ctx.fillStyle = this.color;
        }
        ctx.fill(path, 'evenodd');
        if (this.displayHitBox) {
            const path = new Path2D();
            ctx.lineWidth = 3;
            if (this.hitBoxType === HitBoxTypes.TRIANGLE) {
                const [point1, point2, point3] = this.addOffsetToPoints(this.getRotatedPoints(this.points), originCords);
                path.moveTo(point1.x, point1.y);
                path.lineTo(point2.x, point2.y);
                path.lineTo(point3.x, point3.y);
                path.closePath();
                ctx.strokeStyle = 'blue';
                ctx.stroke(path, 'evenodd');
            }
            else {
                const { tl, br } = this.getTriangleSquare(originCords);
                tl.x = tl.x - this.hitBoxOffsetXLeft;
                tl.y = tl.y - this.hitBoxOffsetYTop;
                br.x = br.x + this.hitBoxOffsetXRight;
                br.y = br.y + this.hitBoxOffsetYBottom;
                path.moveTo(tl.x, tl.y);
                path.lineTo(br.x, tl.y);
                path.lineTo(br.x, br.y);
                path.lineTo(tl.x, br.y);
                path.closePath();
                ctx.strokeStyle = 'blue';
                ctx.stroke(path, 'evenodd');
            }
        }
    }
    moveElement(deltaX, deltaY) {
        this.x += deltaX;
        this.y += deltaY;
        this.points = this.points.map(point => {
            point.x += deltaX;
            point.y += deltaY;
            return point;
        });
    }
    get isOutsideOfScreenArea() {
        const { tl, br } = this.getTriangleSquare();
        const width = br.x - tl.x;
        const height = br.y - tl.y;
        return tl.x + width <= 0 || tl.x >= SCREEN_WIDTH || tl.y + height <= 0 || tl.y >= SCREEN_HEIGHT;
    }
    getTriangleSquare(originCoords = { x: 0, y: 0 }) {
        const [point1, point2, point3] = this.addOffsetToPoints(this.getRotatedPoints(this.points), originCoords);
        let tl = { x: point1.x, y: point1.y };
        let br = { x: point1.x, y: point1.y };
        tl.x = point2.x < tl.x ? point2.x : tl.x;
        tl.x = point3.x < tl.x ? point3.x : tl.x;
        tl.y = point2.y < tl.y ? point2.y : tl.y;
        tl.y = point3.y < tl.y ? point3.y : tl.y;
        br.x = point2.x > br.x ? point2.x : br.x;
        br.x = point3.x > br.x ? point3.x : br.x;
        br.y = point2.y > br.y ? point2.y : br.y;
        br.y = point3.y > br.y ? point3.y : br.y;
        return { tl, br };
    }
    getRenderBox() {
        return this.getTriangleSquare();
    }
}
